import { Box, styled, Typography } from '@mui/material';

export const StyledMessageRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isUser'
})<{ isUser: boolean }>(({ isUser }) => ({
  display: 'flex',
  justifyContent: isUser ? 'flex-end' : 'flex-start'
}));

export const StyledMessageBubble = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isUser'
})<{ isUser: boolean }>(({ theme, isUser }) => ({
  maxWidth: '85%',
  padding: theme.spacing(2, 3),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: isUser
    ? theme.palette.primary.main
    : theme.palette.action.hover,
  color: isUser
    ? theme.palette.primary.contrastText
    : theme.palette.text.primary,
  whiteSpace: 'pre-wrap',
  overflowWrap: 'anywhere'
}));
